export default __webpack_public_path__ + "static/media/default.bb2d8081.svg";